import { http } from 'wagmi';
import { mainnet, sepolia, bsc, bscTestnet } from 'wagmi/chains';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { NETWORK_ENV, chainConfig } from './chains';

const isMainnet = NETWORK_ENV === 'mainnet';
const ethChain = isMainnet ? mainnet : sepolia;
const bscChain = isMainnet ? bsc : bscTestnet;

export const supportedChains = [ethChain, bscChain];

// VIIT is delivered on BSC, so BSC is the canonical "home" chain. Expose it so
// AppKit can connect WalletConnect wallets (Trust Wallet mobile) on BSC by
// default instead of falling back to the first network in the list (Ethereum).
export { ethChain, bscChain };
export const defaultNetwork = bscChain;

// WalletConnect / Reown project ID — get one free at https://cloud.reown.com.
// Required for the AppKit modal (MetaMask, Trust, Rainbow, Coinbase, 300+ wallets).
export const WC_PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '';

// Pin RPC endpoints rather than letting viem pick its rotating defaults.
// viem's default for sepolia is sepolia.drpc.org which is NOT in the nginx
// CSP allow-list — every read fails with "Refused to connect because it
// violates the document's Content Security Policy". Override via env so the
// frontend stays aligned with whatever RPC the deploy is allowed to reach.
export const ETH_RPC_URL =
  process.env.REACT_APP_ETH_RPC_URL ||
  process.env.REACT_APP_SEPOLIA_RPC_URL ||
  chainConfig('ethereum').defaultRpc;
export const BSC_RPC_URL =
  process.env.REACT_APP_BSC_RPC_URL ||
  process.env.REACT_APP_BSC_TESTNET_RPC_URL ||
  chainConfig('bsc').defaultRpc;

// AppKit's Wagmi adapter wires up injected (MetaMask, Trust extension, Brave,
// Rabby, etc.), WalletConnect (Trust mobile, Rainbow, Coinbase mobile, 300+),
// and CoinbaseWallet connectors automatically — no manual connector list.
export const wagmiAdapter = new WagmiAdapter({
  projectId: WC_PROJECT_ID,
  networks: supportedChains,
  transports: {
    [ethChain.id]: http(ETH_RPC_URL),
    [bscChain.id]: http(BSC_RPC_URL),
  },
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;

export const getChainById = (chainId) => supportedChains.find(c => c.id === chainId);
export const isSupportedChain = (chainId) => supportedChains.some(c => c.id === chainId);

export const SUPPORTED_NETWORKS = {
  [ethChain.id]: {
    name: ethChain.name,
    shortName: 'ethereum',
    rpcUrl: ETH_RPC_URL,
    blockExplorer: ethChain.blockExplorers.default.url,
    nativeCurrency: ethChain.nativeCurrency,
    type: 'evm',
  },
  [bscChain.id]: {
    name: bscChain.name,
    shortName: 'bsc',
    rpcUrl: BSC_RPC_URL,
    blockExplorer: bscChain.blockExplorers.default.url,
    nativeCurrency: bscChain.nativeCurrency,
    type: 'evm',
  },
};